import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/AppContext"
import { DatePicker } from "antd"
import dayjs from "dayjs"
import { PostCallWithErrorResponse, simpleGetCall } from "../../api/ApiServices"
import ApiConfig from "../../api/ApiConfig"
import { monthNames } from "../../constant/monts"
import Loader from "../Loader"




function WeekAttendance() {

    const { sidebar } = useContext(AppContext)

    const [isLoading, setISLoading] = useState(false)

    const [attendances, setAttendances] = useState([])

    const date = new Date()
const [selectedDate, setSelectDate] = useState({
    week: 1,
    month: date.getMonth() + 1, // use +1 to match month index starting from 1
    year: date.getFullYear(),
    LocationId: 887,
    CompleteStatus: 0
});

    useEffect(() => {
        getWeeklyAttendance()

    }, [selectedDate])

    const getWeeklyAttendance = () => {

        setISLoading(true)

        PostCallWithErrorResponse(ApiConfig.GET_WEEKLY_HOURS, JSON.stringify(selectedDate)).then((res) => {

            if (res?.json?.Success) {
                setAttendances(res?.json?.Data)
            } else {
                setAttendances([])
            }
            setISLoading(false)

        })

    }

    return (
        <>

            <div
                className={sidebar ? "taskMain " : "cx-active taskMain"}
                id="cx-main"
            >
                <div className="role-content">
                    <div className="sub-header-role ">
                        <h6 className="mt-2">Employee Weekly Hours  </h6>

                    </div>
                    <div className="d-flex justify-content-between role-searchbar-and-btns RspSalary">
                        <div className="role-table-header">
                   <div className="entries-wrapper">
  {/* Month Select */}
  <select
    className="form-select select-drop-icon"
    aria-label="Select Month"
    value={selectedDate.month}
    onChange={(e) => {
      setSelectDate(prev => ({
        ...prev,
        month: Number(e.target.value)
      }));
    }}
  >
    {
      monthNames?.map((month, index) => (
        <option key={index} value={index + 1}>{month}</option>
      ))
    }
  </select>
</div>

<div className="entries-wrapper">
  {/* Week Select */}
  <select
    className="form-select select-drop-icon"
    aria-label="Select Week"
    value={selectedDate.week}
    onChange={(e) => {
      setSelectDate(prev => ({
        ...prev,
        week: Number(e.target.value)
      }));
    }}
  >
    <option value="1">1st Week</option>
    <option value="2">2nd Week</option>
    <option value="3">3rd Week</option>
    <option value="4">4th Week</option>
    <option value="5">5th Week</option>
  </select>
</div>

<div className="entries-wrapper">
  {/* Location Select */}
  <select
    className="form-select select-drop-icon"
    aria-label="Select Location"
    value={selectedDate.LocationId}
    onChange={(e) => {
      setSelectDate(prev => ({
        ...prev,
        LocationId: Number(e.target.value)
      }));
    }}
  >
    <option value="887">Head Office</option>
    <option value="888">Branch A</option>
    <option value="889">Branch B</option>
    {/* Add more locations as needed */}
  </select>
</div>

<div className="entries-wrapper">
  {/* Complete Status Select */}
  <select
    className="form-select select-drop-icon"
    aria-label="Complete Status"
    value={selectedDate.CompleteStatus}
    onChange={(e) => {
      setSelectDate(prev => ({
        ...prev,
        CompleteStatus: Number(e.target.value)
      }));
    }}
  >
    <option value="0">All</option>
    <option value="1">Completed</option>
    <option value="2">Pending</option>
  </select>
</div>


                        </div>

                    </div>
                    <div className="table-wrapper-main" id="scrol-tblNtable-wrapper-af">
                        {
                            isLoading ? <div>
                                <Loader />
                            </div> :

                                <table>
                                    <thead>
                                        <tr className="firstTabelRow">
                                            <th>Sr.no</th>
                                            <th>Employee Name</th>
                                            <th>Total Hours</th>
                                            <th>Completed Hours</th>
                                            <th>Pending Hours </th>
                                        </tr>
                                    </thead>
                                    <tbody>


                                        {
                                            attendances?.map((attendance, index) => {

                                                return <tr className="table-row-custom" key={index}

                                                >
                                                    <td className="textStart">{index + 1}</td>
                                                    <td>{attendance?.EmployeeName}</td>
                                                    <td>{attendance?.TotalHours}</td>
                                                    <td>{attendance?.CompletedHours}</td>
                                                    <td >{attendance?.PendingHours}</td>
                                                </tr>

                                            })
                                        }
                                        {/* <td>{startIndex + index + 1}</td>
                                                <td>{data.EmployeeName}</td>
                                                <td>{data.ProjectName}</td>
                                                <td>{data.ProjectLead}</td>
                                                <td>{data.ResourceFromDate}</td>
                                                <td>{data.ResourceToDate}</td> */}


                                    </tbody>
                                </table>
                        }

                    </div>
                </div>

            </div >
        </>
    )

}

export default WeekAttendance